import { defineMessage } from 'services/localization';

export const messages = {
    allFilterTitle: defineMessage('all'),
    onReviewFilterTitle: defineMessage('on_review_1'),
    onApprovalFilterTitle: defineMessage('on_approval_1'),
    approvedFilterTitle: defineMessage('approved'),
    cancelledFilterTitle: defineMessage('cancelled'),
    rejectedFilterTitle: defineMessage('rejected'),
    onHoldFilterTitle: defineMessage('on_hold_1'),
    billedFilterTitle: defineMessage('billed'),
    notBilledFilterTitle: defineMessage('not_billed'),
    paidFilterTitle: defineMessage('paid'),
    acceptedFilterTitle: defineMessage('accepted'),
    declinedFilterTitle: defineMessage('declined'),
    awaitingPayment: defineMessage('awaiting_payment'),
    partiallyPaid: defineMessage('partially_paid'),
    failed: defineMessage('failed'),
    processing: defineMessage('processing'),
    grnNotReceived: defineMessage('not_received'),
    grnPartiallyReceived: defineMessage('partially_received'),
    grnFullyReceived: defineMessage('fully_received'),
    searchResultsPageName: defineMessage('search_results'),
    requestsPageName: defineMessage('requests'),
    deadlineText: defineMessage('due_deadline'),
    deadlineTitle: defineMessage('deadline_deadline'),
    creditedFilterTitle: defineMessage('credited'),
    partiallyReceivedTitle: defineMessage('partially_received'),
    pendingReceiptTitle: defineMessage('pending_receipt'),
    pendingBillTitle: defineMessage('pending_bill'),
    closedTitle: defineMessage('closed'),
};
